import authReducer from "./authReducer";
import registrationReducer from "./registrationReducer";

const iamReducers = {
    auth: authReducer,
    registration: registrationReducer
}

export default iamReducers;